import { createApi } from '@reduxjs/toolkit/query/react';
import { buildBaseQuery } from 'app/api';
import { AddressSearch, AreaSearch } from 'app/types/addressSearch';
import { QuickSearch } from 'app/types/search';
import { toQueryString } from 'utils/url';
import { AreaOption, StreetOption, toAreaOptions, toStreetOptions } from './types';

const name = 'addressApi';

const tags = {
  LIST: 'LIST',
  ENTITY: 'ENTITY',
};

export const addressApi = createApi({
  reducerPath: name,
  baseQuery: buildBaseQuery('api/addresses'),
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    getAreas: builder.query<AreaOption[], AreaSearch>({
      query: (search) => `areas?${toQueryString(search)}`,
      providesTags: [ tags.LIST ],
      transformResponse: (response: any) => toAreaOptions(response.AreaList),
    }),
    getStreets: builder.query<StreetOption[], AddressSearch>({
      query: (search) => `streets?${toQueryString(search)}`,
      providesTags: [ tags.LIST ],
      transformResponse: (response: any) => toStreetOptions(response.AddressList),
    }),
    // TODO: Needs input from client before usage
    getAddresses: builder.query<QuickSearch[], string>({
      query: (search) => `?search=${search}`,
      providesTags: [ tags.LIST ],
      transformResponse: (response: any) =>
        response.AddressList.map((address: any) => ({ label: address.Text, value: address.Id })),
    })
  }),
  refetchOnMountOrArgChange: true,
});

export const {
  useLazyGetAreasQuery,
  useLazyGetStreetsQuery,
} = addressApi;